import React from 'react'
import { SHAPE_IDS, SHAPE_LABELS } from '../utils/shapes'
import './ShapeSelector.css'

function ShapeIcon({ shape }) {
  // Tiny SVG icons rendered inside the picker buttons.
  switch (shape) {
    case 'square':
      return (
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <rect x="4" y="4" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" />
        </svg>
      )
    case 'circle':
      return (
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="2" />
        </svg>
      )
    case 'open_circle':
      return (
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <path d="M20 12a8 8 0 1 1-3.2-6.4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      )
    case 'triangle':
      return (
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <polygon points="12,4 20,20 4,20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
      )
    case 'trapezoid':
      return (
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <polygon points="8,6 16,6 20,18 4,18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
      )
    case 'hexagon':
      return (
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <polygon points="12,3 20,7.5 20,16.5 12,21 4,16.5 4,7.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
      )
    case 'letter_z':
      return (
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <polyline points="5,6 19,6 5,18 19,18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        </svg>
      )
    default:
      return null
  }
}

function ShapeSelector({ side, selected, onSelect }) {
  return (
    <div className="shape-selector" role="group" aria-label={`Pick shape for ${side} hand`}>
      {SHAPE_IDS.map((shapeId) => (
        <button
          key={shapeId}
          type="button"
          data-testid={`shape-button-${side}-${shapeId}`}
          aria-label={SHAPE_LABELS[shapeId]}
          aria-pressed={selected === shapeId}
          className={`shape-selector__btn${selected === shapeId ? ' is-selected' : ''}`}
          onClick={() => onSelect(side, shapeId)}
        >
          <ShapeIcon shape={shapeId} />
        </button>
      ))}
    </div>
  )
}

export default ShapeSelector
